import { render, staticRenderFns } from "./edit-tax-modal.vue?vue&type=template&id=09d4b720&scoped=true"
import script from "./edit-tax-modal.vue?vue&type=script&lang=js"
export * from "./edit-tax-modal.vue?vue&type=script&lang=js"
import style0 from "./edit-tax-modal.vue?vue&type=style&index=0&id=09d4b720&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d4b720",
  null
  
)

export default component.exports